var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"background",class:_vm.$style.image,style:(_vm.dinamicStyle),attrs:{"role":"presentation"}},[_c('span',{class:_vm.$style.icon},[_c('FontAwesomeIcon',{style:({ color: 'white' }),attrs:{"icon":_vm.icon,"fixed-width":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }